<style scoped>
@import url("../assets/css/info.css");
</style>

<template>
  <div class="info-content">
    <van-nav-bar @click-left="pageBack" title="详情" fixed :z-index="1000" class="menu-title-box">
      <img slot="left" src="../assets/image/icon_v2/return_white@2x.png" class="return_icon" />
    </van-nav-bar>
    <div class="book">
      <div class="img-center">
        <van-image :src="book.cover" />
      </div>
      <div class="book-title font-m">{{book.name}}</div>
      <div class="book-volume" v-if="volumes">
        <div
          class="volume"
          :class="activeClass == index?'active':''"
          v-for="(volume,index) in volumes"
          :key="index"
          @click="choseVolume(volume.volume_id,index)"
        >{{volume.name}}</div>
      </div>
    </div>
    <div class="book-info-box">
        <div class="book-info">
            <div class="info-detail">
                <p class="key">作&nbsp;&nbsp;&nbsp;者</p>
                <p v-if="book.author" class="name">{{book.author}}</p>
                <p v-else class="name">不详</p>
            </div>
            <div class="info-detail">
                <p class="key">时&nbsp;&nbsp;&nbsp;期</p>
                <p v-if="book.dynasty" class="name">{{book.dynasty}}</p>
                <p v-else class="name">不详</p>
            </div>
            <div class="info-detail">
                <p class="key">版本项</p>
                <p v-if="book.version" class="name">{{book.version}}</p>
                <p v-else class="name">不详</p>
            </div>
            <div class="info-detail">
                <p class="key">藏馆地</p>
                <p v-if="book.collect" class="name">{{book.collect}}</p>
                <p v-else class="name">不详</p>
            </div>
        </div>
    </div>
    <button class="book-btn" @click="readImg()">
        立即阅读
    </button>
  </div>
</template>

<script>
import { Image } from "vant";
export default {
  data() {
    return {
      bookId: null,
      volumeId: null,
      book: {},
      volumes: {},
      volumeId: null,
      activeClass: 0,
    };
  },
  methods: {
    bookInfo(bookId) {
      var that = this;
      this.$api.get("/book/info/" + bookId).then(function(res) {
        that.book = res.data.data;
        that.volumes = that.book.book_volumes;
        that.shareConfig();
        that.volumes.forEach((volume,index) => {
            if(index == 0) {
                that.volumeId = volume.volume_id;
            }
        });
      });
    },
    choseVolume(volumeId, selectIndex) {
      this.volumeId = volumeId;
      this.activeClass = selectIndex;
    },
    readImg() {
        // this.$router.push({path:'/read/'+this.volumeId+'/'+this.bookId})
        this.$router.push({path:'/read',
        query:{
          vid:this.volumeId,
          bid:this.bookId,
        }})
    },
    pageBack() {
      this.$router.push({path:'/'})
    },
    shareConfig() {
      let url = window.location.href.split('#')[0]
      let obj = {
        title: '您的好友邀您一起欣赏《'+this.book.name+'》',
        desc: '我能想到最好的礼物就是把好书推荐给你。',
        link: url,
        imgUrl:this.book.cover
      }
      this.$wxApi.getJSSDK(url,obj)
    }
  },
  created() {
    this.bookId = this.$route.params.book_id;
    this.bookInfo(this.bookId);

    const hashLocation = this.$route.path
		const url = "https://m.kanguji.com"+hashLocation
		this.$matomo.setCustomUrl(url);
  },
  components: {
    [Image.name]: Image,
  }
};
</script>


// WEBPACK FOOTER //
// src/components/info.vue